<template>
    <div>
        <nav-breadcrumb :menu="[{label: '详情'}]"/>
        <panel  label="基本信息">
            <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                <el-row :gutter="10" class="bg-purple xamhtrpg">
                    <el-col :span="24" >
                        <el-form-item label="用印类型：" prop="t__applicationTypeCode" >
                            {{dataForm.t__applicationTypeCode|Status2CN}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="用印日期：" prop="t__applicationDate" >
                            {{dataForm.t__applicationDate|moment('YYYY-MM-DD')}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="所需盖章：" prop="t__companySeal" >
                            <el-checkbox  v-model="dataForm.t__companySeal" true-label="Y" false-label="N" disabled>公章</el-checkbox>
                            <el-checkbox  v-model="dataForm.t__legalRepSeal" true-label="Y" false-label="N" disabled>法人章</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="用印描述：" style="width: 60%">
                            <el-input type="textarea" v-model="dataForm.t__remarks" style="margin-bottom:10px;" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </panel>
        <panel title="盖章文件" v-for="(item,idx) in dataForm.detail"
               :key="idx" >
            <files-data-table :files="item.fileList"  :additional-columns="additionalColumns" ></files-data-table>
        </panel>
        <panel label="">
            <el-row>
                <el-col class="grid-content bg-purple">
                    <el-tabs v-model="tabName">
                        <template>
                            <el-tab-pane label="审核流程" name="tabName1">
                                <data-table
                                    :table-data="{data: dataForm.approvals||[]}"
                                    :columns="approvalTableColumns"
                                    :is-pagination-show="false"
                                />
                            </el-tab-pane>
                            <el-tab-pane label="流程图" name="tabName2">
                                <img
                                    src="../../assets/images/TY.png"  style="width: 100%"></img>
                            </el-tab-pane>
                        </template>
                    </el-tabs>
                </el-col>
            </el-row>
        </panel>
        <div class="tr xzmt">
            <el-button @click="$router.back()">返回</el-button>
        </div>
        <!--<el-dialog title="选择"
                   :visible.sync="dialogVisible" @close="dataRelaod()">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </el-dialog>-->
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import Status2CN from "../../filters/Status2CN";
    import moment from 'moment'
    import Panel from "../../components/Panel";
    import {formatMoney} from "../../filters/CommonFilters";
    import {xmlBuildQuery} from "../../filters/CommonActions";
    export default {
        name: "ApproveContractSealProcess",
        data(){
            return {
                applicationId: this.$route.query['applicationId']||'',
                tabName:'tabName1',
                bankFormFiles: [],
                dataFormRules: {},
                dialogVisible:false,
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions:[],
                filters: {
                    labelWidth: '150px',
                    form: {
                        fi__transactionNo:'',
                        fi__customerName:'',
                        /* c__customerContactNo:'',
                         d__dealerId:'',
                         fi__transactionDate:[],
                         fi__transactionStatus:'',
                         fi__repaymentFormula:'',
                         overdue:'',*/
                    },
                    columns: [
                        {
                            label: '贷款编号',
                            component: 'el-input',
                            field: 'fi__transactionNo',

                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'fi__customerName',
                            span:12

                        },


                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                },
                additionalColumns: [
                    {
                        label: '盖章份数',
                        field: 'copies',
                        formatter: function (r,c,v) {
                            if(v)
                                return v
                            else
                                return 0
                        }
                    }
                ],
                selectKeys:-1,
                dataFormTemp: {
                    t__companySeal:'N',
                    t__legalRepSeal:'N',
                    checkList:['N','N'],
                    detail:[{
                        fileList: [],
                    }]
                },
                approvalTableColumns: [
                    {
                        label: '节点',
                        field: 'a__nodeName',
                        formatter: (r,c,v)=> {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '操作人',
                        field: 'a__approverName'
                    },
                    {
                        label: '操作时间',
                        field: 'a__approvingDate',
                        formatter: (r,c,v)=>{
                            if(v)
                                return moment(v).format('YYYY-MM-DD HH:mm:ss')
                            else
                                return ''
                        }
                    },
                    {
                        label: '操作结果',
                        field: 'a__approvingStatus',
                        formatter: (r,c,v)=> {
                            if(v)
                                return Status2CN(v)
                            else
                                return ''
                        }
                    },
                    {
                        label: '操作备注',
                        field: 'a__remarks'
                    }
                ]
            }
        },
        filters: {

            Status2CN
        },
        computed:{

            dataForm(){
                return this.dataFormTemp
            },
            filterParams: {
                get: function() {
                    return {
                        pageSize: this.pageSize,
                        pageOffset: (this.page - 1) * this.pageSize,
                        'xlist.search.fi.transactionStatus' : 'Processing,Ready,Settled',
                        'xlist.search.fi.transactionStatus.op' : 'in',
                        'xlist.sort.dataField': 'fi.startDate',
                        'xlist.sort.order': 'desc'
                    }
                },
                set:function (newVal) {

                }
            }
        },
        mounted() {
            if(this.applicationId){
                this.getData2()
            }
        },
        methods: {
            getData2:function(){
                xhr.getViewSealApplication({
                        't.applicationId': this.applicationId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.dataFormTemp = res.data.data
                                this.dataFormTemp.detail.forEach((item, idx)=>{
                                    xhr.getPayee(
                                        Object.assign({
                                            'xlist.search.p.payeeId' : item.de__referenceId,
                                            'xlist.search.p.payeeId.op' : 'in',
                                        }, {},{}),
                                        res1 => {
                                            try {
                                                let row = res1.data.data[0]
                                                item.text = row.p__payeeName


                                                this.$set(this.dataFormTemp.detail, idx, item)
                                                item.fileList=[]
                                                item.de__docs.forEach(items=>{
                                                    item.fileList.push({
                                                        'name':items.fileName,
                                                        'size':items.fileSize,
                                                        'fileId':items.fileURL,
                                                        'copies':items.copies,
                                                    })
                                                })

                                                this.$set(this.dataFormTemp.detail, idx, item)
                                            } catch (e) {

                                            }
                                        })

                                })
                                this.dataFormTemp.approvalArry = []
                                this.dataFormTemp.approvalArry.push(
                                    {
                                        a__nodeName: '项目申请人',
                                        a__approverName: this.dataFormTemp.u__userName,
                                        a__approvingDate: this.dataFormTemp.t__createdDate,
                                        a__approvingStatus: '提交成功',
                                        a__remarks: '',

                                    }
                                )
                                this.dataFormTemp.approvals.filter(items=>items.a__approvalType).forEach(item=>{
                                    this.dataFormTemp.approvalArry.push(
                                        {
                                            a__nodeName: item.a__nodeName,
                                            a__approverName: item.a__approverName,
                                            a__approvingDate: item.a__approvingDate,
                                            a__approvingStatus: Status2CN(item.a__approvingStatus),
                                            a__remarks: item.a__remarks,

                                        }
                                    )
                                })
                                this.dataFormTemp.approvals = this.dataFormTemp.approvalArry
                            }
                        }catch (e) {

                        }
                    })
            },
            Status2CN,



            getData: function () {
                xhr.getFinancingFangSelect(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res => {
                        try {
                            this.tableData = res.data
                        } catch (e) {

                        }
                    })
            },
            onSubmit :function (status) {
                this.dataForm.a__approvingStatus = status
                xhr.ApproveSealApplication(
                    this.dataForm,
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.$router.push({
                                    name: 'ContractSealProcessListView'
                                })
                            }else{
                                this.$message.error(res.data.msgs[0].text)
                            }

                        }catch (e) {

                            this.$message.error(error.msgs[0].text)

                        }
                    }
                )
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ApproveContractSealProcessTYView.vue